
export default [
    {
        path: '/admin/loan-type-user-defined-rates',
        name: 'loan-type-user-defined-rate',
        meta: { requiresAuth: true },
        component: () => import('@/pages/credit-operation/loan-type-user-defined-rates')
    }
]
